// eslint-disable-next-line import/prefer-default-export
export const updateObjectInArrayByKey = (array, object, key) =>
  array.map((x) => (x[key] === object[key] ? object : x));
